'use client';

import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import type { DynamicTranslator } from '@/lib/errors/resolve-api-error';
import { setToastTranslator } from '@/lib/i18n/toast-translator';

/**
 * Registers the live root translator into the `toast-translator` singleton so
 * imperative (non-component) call sites can translate snackbars. Mounted once,
 * inside the locale tree, alongside `MutationErrorListener`.
 */
export function ToastTranslatorBridge(): null {
  // ALLOW-UNKNOWN: next-intl `t` is typed against the static message tree; imperative toasts dispatch dynamic keys, so we narrow the function shape (not the value).
  const t = useTranslations() as unknown as DynamicTranslator;

  useEffect(() => {
    setToastTranslator(t);
    return () => {
      setToastTranslator(null);
    };
  }, [t]);

  return null;
}
